import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

type EmptyStateProps = {
	title: string;
	description?: string;
	action?: ReactNode;
};

/** Centered empty state of a list: title, optional description and optional action (e.g. an Add button). */
export default function EmptyState({ title, description, action }: EmptyStateProps) {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				flexGrow: 1,
				gap: 4,
				p: 8,
				textAlign: 'center',
			}}
		>
			<Typography
				variant="h2"
				sx={{ fontFamily: 'Roboto, Helvetica, Arial, sans-serif', fontSize: '1.5rem', fontWeight: 'bold' }}
			>
				{title}
			</Typography>
			{description && <Typography color="textSecondary">{description}</Typography>}
			{action}
		</Box>
	);
}
